import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import WebsiteGenerator from "./pages/GenerateWebsitePage";
import ProgramsManagerPage from "./pages/ProgramsManagerPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/generate" element={<WebsiteGenerator />} />
                <Route path="/crm/programs" element={<ProgramsManagerPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;